module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo_minor/lmi_border-702074b34b98a94a928eb9c03d09a479.gif";